export const FORECAST_STATUS = Object.freeze({ DRAFT: 1, PENDING: 2, ACTIVE: 3, CLOSED: 4 });

export const FORECAST_WINDOW_STATUS = Object.freeze({ DRAFT: 1, SUBMITTED: 2, RE_CHALLENGED: 3, SAVED: 4 });

export const ITEM_STATUS = Object.freeze({ ACTIVE: "active", IN_PROGRESS: "in_progress", NEW: "new", OBSOLETE: "obsolete", CANCELLED: "cancelled" });

export const FUNCTIONALITY = "forecasts_manager";

export const RECURRENCE_TYPE = Object.freeze({ /*WEEKS: 1,*/ MONTHS: 2 });

export function recurrenceTypeLabel(type) {
    if (type === RECURRENCE_TYPE.WEEKS) {
        return "Weeks";
    }
    if (type === RECURRENCE_TYPE.MONTHS) {
        return "Months";
    }
}



// WEBPACK FOOTER //
// ./src/components/forecasts/constants.js